/* Start Slider Swipe */
function addTopSwiping(bar, direction = "next") {
  const swiperContainer = bar.querySelector(".hn-0010-slider-container");
  const swiperItems = bar.querySelectorAll(".hn-0010-slide");

  const itemWidth = swiperItems[0].offsetWidth;
  const containerScrollPosition = swiperContainer.scrollLeft;

  let newScrollPosition;
  if (direction === "next") {
    newScrollPosition = containerScrollPosition + itemWidth;
    if (
      newScrollPosition >=
      swiperContainer.scrollWidth - swiperContainer.clientWidth
    ) {
      newScrollPosition = 0;
    }
  } else if (direction === "prev") {
    newScrollPosition = containerScrollPosition - itemWidth;
    if (newScrollPosition < 0) {
      newScrollPosition =
        swiperContainer.scrollWidth - swiperContainer.clientWidth;
    }
  }

  swiperContainer.scrollTo({
    left: newScrollPosition,
    behavior: "smooth",
  });
}

function startTopSwiping() {
  const bar = document.querySelector(".hn-0010-slider");
  if (bar) {
    setInterval(() => addTopSwiping(bar, "next"), 4000);
  }
}
/* End Slider Swipe */

/* Start Custom Message */
function customFunction() {
  //Data
  const html = document.querySelector("html");
  const opener = document.querySelector(".hn-0010-slide:first-child");
  const message = document.querySelector(".hn-0010-slider-custom");
  const close = document.querySelector(".hn-0010-slider-custom-overlay");

  if(opener && message && close){
  //Click Event to Show message
  opener.addEventListener("click", () => {
    html.classList.add("lock-all");
    message.classList.add("active");
  });

  //Click Event to close message
  close.addEventListener("click", () => {
    html.classList.remove("lock-all");
    message.classList.remove("active");
  });
  }
}

/* End Custom Message */

//Initial
startTopSwiping();
customFunction();